import React, { useState, useEffect } from 'react';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../../utils/Verifiers.jsx';

const ListaNuevosRegistrosSiembraCampo = (p) => {
    const close = p.close ?? (() => { });
    const eliminarElementoLista = p.eliminarElementoLista ?? (() => { });
    const keys = ['bloque', 'semana_siembra', 'semana_trasplante', 'semana_corte', 'ciclo_campo', 'plantas', 'germinacion', 'semillas', 'densidad', 'metros2', 'recuperacion', 'tallos'];
    const listeRegistros = p.listeRegistros ?? [];
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    var counter = 0;

    useEffect(() => { }, [p.listeRegistros]);

    const keyGen = () => {
        counter++;
        return counter + "planes de envio";
    }

    const guardarRegistrosServidor = async () => {
        let resp = await Post('campo/v2/siembra/add', { registros: JSON.parse(JSON.stringify(listeRegistros)) }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error al guardar los datos', 'error');
            return;
        }
        close(true);
    }

    return (
        <>
            <div className='w-100 p-0 m-0'>
                <div className='row justify-content-evenly w-100 m-0 p-0 pt-1'>
                    <div className='w-100 border ps-1 pe-1 pt-0 pb-1 round-m shadow-sm' style={{ maxHeight: "50vh", overflow: "auto" }}>
                        {listeRegistros.length > 0 && <table className='table table-sm table-hover'>
                            <thead>
                                <tr>
                                    {['Bloque', 'S. siembra', 'S. trasplante', 'S. corte', 'Ciclo campo', 'Núm. plantas', 'Germinación', 'Semillas', 'Densidad', 'Metros²', 'Recuperación', 'Tallos cosecha', 'opciones'].map((t, k) =>
                                        <th key={keyGen()} className={'nowrap bg-black text-white' + (
                                            k === 0 ? ' round-top-left-m' : k === 12 ? ' round-top-right-m' : ' border border-white'
                                        )}>{t}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {listeRegistros.map((reg, i) => <tr key={keyGen()}>
                                    {keys.map((k) => <td key={keyGen()} className='nowrap'>{reg[k]}</td>)}
                                    <td>
                                        <button className='btn btn-sm btn-danger round-xxl border border-dark w-100 shadow text-bold' onClick={() => eliminarElementoLista(i)} >
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                        }
                        {listeRegistros.length === 0 && <div className='w-100 text-center text-300'>
                            No hay registros para mostrar, llene los campos del formulario y pulse el botón<span className='text-bold ms-2'>Agregar a la lista</span>
                        </div>}
                    </div>
                    {listeRegistros.length > 0 && <div className='bw-350 mt-3 mb-3'>
                        <button className='btn btn-sm btn-success bg-green3 round-xxl border border-dark w-100 shadow text-bold' onClick={guardarRegistrosServidor}
                        >Guardar registro(s)</button>
                    </div>}
                </div>
            </div>

            <VainillaDialog data={dialog} />
            {loader && ldr}
        </>

    )
}

export default ListaNuevosRegistrosSiembraCampo;